module.exports = __webpack_public_path__ + "static/media/portugal.acb8bddd.svg";